import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { MarketSelector } from './MarketSelector';
const TICKER = [{
  text: '50% OFF',
  color: 'text-sun'
}, {
  text: '10 bonos gratis',
  color: 'text-white'
}, {
  text: 'Pasaporte creativo de regalo',
  color: 'text-coral'
}, {
  text: 'Acceso digital inmediato',
  color: 'text-white'
}, {
  text: '365 ideas listas',
  color: 'text-sky'
}];
function TickerGroup() {
  return <>
      {TICKER.map((item, i) => <span key={`${item.text}-${i}`} className="flex shrink-0 items-center" data-id="element-249" data-mp="2lu6jkw2a9c2l" data-mpi={i}>
          <span className={['whitespace-nowrap px-3 font-display text-[11px] font-extrabold uppercase tracking-[0.14em] sm:text-xs', item.color].join(' ')} data-id="element-250" data-mp="2h1de25yzpzpg">
            {item.text}
          </span>
          <span className="text-sun/90" aria-hidden="true" data-id="element-251" data-mp="34sisqht72ly6">
            ✦
          </span>
        </span>)}
    </>;
}
export function TopBar() {
  const reduce = useReducedMotion();
  return <div className="sticky top-0 z-50 w-full bg-navy" data-id="element-252" data-mp="66ky279m2uj3">
      <div className="flex items-center" data-id="element-253" data-mp="661fcoc50240">
        <div className="relative flex-1 overflow-hidden py-2.5" data-id="element-254" data-mp="3olc2pnxghxim">
          <motion.div className="flex w-max" animate={reduce ? undefined : {
          x: ['0%', '-50%']
        }} transition={{
          duration: 26,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-255" data-mp="3oipvjpeh9k0x">
            <div className="flex shrink-0" data-id="element-256" data-mp="3eoz72kicp9l8">
              <TickerGroup data-id="element-257" data-mp="3jmsd9djnm3li" />
              <TickerGroup data-id="element-258" data-mp="3jn0utiqq1x31" />
              <TickerGroup data-id="element-259" data-mp="35ly60y8ce8of" />
            </div>
            <div className="flex shrink-0" aria-hidden="true" data-id="element-260" data-mp="35n9j5onogss7">
              <TickerGroup data-id="element-261" data-mp="3akrh6k05pnlf" />
              <TickerGroup data-id="element-262" data-mp="3am2lckxikxd2" />
              <TickerGroup data-id="element-263" data-mp="3alb1u8h6yq35" />
            </div>
          </motion.div>
        </div>
        <div className="hidden shrink-0 border-l border-white/15 px-4 md:block" data-id="element-264" data-mp="13vwd2w9z4euk">
          <MarketSelector tone="dark" id="market-selector-top" data-id="element-265" data-mp="18smupo1ffii3" />
        </div>
      </div>
    </div>;
}